import {
  CreateReportValidateProjectionDocument,
  CreateReportValidateProjectionMutationVariables,
} from 'generated/resources/graphql'

import { useUnsafeCallback } from 'modules/core/hooks/useCallback'
import { useMutation } from 'modules/core/hooks/useMutation'

const useValidateProjections = () => {
  const [validateProjection, { loading }] = useMutation(CreateReportValidateProjectionDocument, {
    extractorFn: (data) => data.reportsMutations.createReportsValidateProjection,
  })

  const validateProjectionMutation = useUnsafeCallback(
    (variables: CreateReportValidateProjectionMutationVariables) => {
      return validateProjection({
        variables,
      })
    },
    [validateProjection]
  )

  return {
    loading,
    validateProjection: validateProjectionMutation,
  }
}

export default useValidateProjections
